import { RingIncomingCallValidatorImpl } from '@main/validators/ring-incoming-call.validator';
import { SyncParticipantsValidatorImpl } from '@main/validators/sync-participants.validator';

export class ValidatorFactory {
  private static ringIncomingCallValidator: RingIncomingCallValidatorImpl;
  static buildRingIncomingCallValidator(): RingIncomingCallValidatorImpl {
    if (!this.ringIncomingCallValidator) {
      this.ringIncomingCallValidator = new RingIncomingCallValidatorImpl();
    }

    return this.ringIncomingCallValidator;
  }

  private static syncParticipantsValidator: SyncParticipantsValidatorImpl;
  static buildSyncParticipantsValidator(): SyncParticipantsValidatorImpl {
    return (
      this.syncParticipantsValidator ??
      (this.syncParticipantsValidator = new SyncParticipantsValidatorImpl())
    );
  }
}
